const e = up.element;
const u = up.util;
const SHIFT_CLASS = 'up-scrollbar-away';
up.BodyShifter = class BodyShifter {
    constructor() {
        this._anchoredElements = new Set();
        this._stack = 0;
        this._cleaner = u.cleaner();
    }
    lowerStack() {
        if (--this._stack === 0)
            this._unshiftNow();
    }
    raiseStack() {
        if (++this._stack === 1)
            this._shiftNow();
    }
    onAnchoredElementInserted(element) {
        this._anchoredElements.add(element);
        this._shiftElement(element, 'right');
        return () => this._anchoredElements.delete(element);
    }
    _isShifted() {
        return this._stack > 0;
    }
    _shiftNow() {
        this._rootScrollbarWidth = up.viewport.rootScrollbarWidth();
        this._cleaner(e.setStyleTemp(e.root, {
            '--up-scrollbar-width': this._rootScrollbarWidth + 'px'
        }));
        this._shiftElement(document.body, 'padding-right');
        for (let element of this._anchoredElements) {
            this._shiftElement(element, 'right');
        }
    }
    _unshiftNow() {
        this._cleaner.clean();
    }
    _shiftElement(element, styleProp) {
        if (!this._isShifted())
            return;
        let originalValue = e.style(element, styleProp);
        this._cleaner(e.setStyleTemp(element, { ['--up-original-' + styleProp]: originalValue }), e.addClassTemp(element, SHIFT_CLASS));
    }
};
